export default __webpack_public_path__ + "static/media/BO.9e0cc5ad.svg";